import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { debounce, get } from '@elliemae/ds-utilities/utils';
import useResizeObserver from '@elliemae/ds-utilities/hooks/useResizeObserver';
import theme from '@elliemae/ds-system/theme';
import getFilterMenuByType from './filterable-menus/getFilterMenuByType.js';
import './filterable-menus/DateRangeFilterMenu.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import '@elliemae/ds-basic/Button';
import 'moment';
import './filterable-menus/defaultDateFormat.js';
import './filterable-menus/SingleDateFilterMenu.js';
import './filterable-menus/SingleRangeSwitcherMenu.js';
import './filterable-menus/TextFilterMenu.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';

var blockName = 'data-grid-filter-header';
var Container = aggregatedClasses('div')(blockName, null, function (_ref) {
  var showFilter = _ref.showFilter;
  return {
    'show-filter': showFilter
  };
});
var FilterHeaderValue = aggregatedClasses('div')(blockName, 'value');
var FilterHeaderButton = aggregatedClasses('div')(blockName, 'button');
function FilterableHeader(_ref2) {
  var column = _ref2.column,
      value = _ref2.value,
      columnData = _ref2.columnData,
      onAddFilter = _ref2.onAddFilter,
      onRemoveFilter = _ref2.onRemoveFilter,
      filterMenuRef = _ref2.filterMenuRef,
      onFilterMenuClose = _ref2.onFilterMenuClose,
      onFilterMenuOpen = _ref2.onFilterMenuOpen,
      filters = _ref2.filters,
      isMulti = _ref2.isMulti;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpened = _useState2[0],
      setMenuOpened = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      headerWidth = _useState4[0],
      setHeaderWidth = _useState4[1];

  var debouncedWidthSetter = debounce(setHeaderWidth, 200);
  var filterMenuMinWidth = column.filterMenuMinWidth,
      filterMenuMaxWidth = column.filterMenuMaxWidth;
  var dropdownMinWidth = filterMenuMinWidth || Number(theme.space.xl.replace('px', '')) * 2;

  var defineHeaderWidth = function defineHeaderWidth(_ref3) {
    var width = _ref3.width;
    var nextWidth = width + 16; // todo: use dimsum space once we convert it to JS

    if (nextWidth < dropdownMinWidth) nextWidth = dropdownMinWidth;
    if (filterMenuMaxWidth && nextWidth > filterMenuMaxWidth) nextWidth = filterMenuMaxWidth;
    return !isMenuOpened ? debouncedWidthSetter(nextWidth) : setHeaderWidth(nextWidth);
  };

  useEffect(function () {
    if (filterMenuRef) {
      filterMenuRef.current = {
        toggleMenu: function toggleMenu() {
          return setMenuOpened(function (prevState) {
            return !prevState;
          });
        }
      };
    }
  }, [filterMenuRef]);
  useEffect(function () {
    if (!isMenuOpened) onFilterMenuClose(column);else onFilterMenuOpen(column);
  });

  var _useResizeObserver = useResizeObserver(defineHeaderWidth),
      _useResizeObserver2 = _slicedToArray(_useResizeObserver, 1),
      ref = _useResizeObserver2[0];

  var handleOpenMenu = useCallback(function (open) {
    setMenuOpened(open);
    if (open) onFilterMenuOpen();
  }, []);
  var FilterMenuComponent = getFilterMenuByType(get(column, ['filter', 'type']));
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    classProps: {
      showFilter: isMenuOpened
    }
  }, /*#__PURE__*/React.createElement(FilterHeaderValue, {
    className: "header-value"
  }, value), /*#__PURE__*/React.createElement(FilterHeaderButton, {
    "data-testid": "data-grid-filter-header__button"
  }, /*#__PURE__*/React.createElement(FilterMenuComponent, _extends({
    className: "filter-header-menu",
    column: column,
    filters: filters,
    isMenuOpened: isMenuOpened,
    isMulti: isMulti,
    menuProps: {
      options: columnData || [],
      style: {
        minWidth: headerWidth,
        maxWidth: filterMenuMaxWidth
      },
      zIndex: 100
    },
    onAddFilter: onAddFilter,
    onRemoveFilter: onRemoveFilter,
    onOpenMenu: handleOpenMenu,
    onClose: onFilterMenuClose,
    width: headerWidth
  }, get(column, ['filter'], {})))));
}
FilterableHeader.propTypes = {
  column: PropTypes.any,
  value: PropTypes.any,
  columnData: PropTypes.any,
  onAddFilter: PropTypes.func,
  onRemoveFilter: PropTypes.func,
  filterMenuRef: PropTypes.any,
  onFilterMenuClose: PropTypes.func,
  onFilterMenuOpen: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  isMulti: PropTypes.bool
};

export default FilterableHeader;
//# sourceMappingURL=FilterableHeader.js.map
